
export class DocumentSearchCriteria {
    public itemKeyId: number;
    public documentCategoryTypeId: number;
    public documentTypeId: number;
    public documentItemKeyTypeId: number;
    startDate?: Date;
    endDate?: Date;
}
